module.exports = __webpack_public_path__ + "img/logo_sm.166c4c44.png";